module.exports = __webpack_public_path__ + "public/img/electricalFire.b2ca70ee.png";